import type { Thread } from '../lib/types'

interface Props {
  thread: Thread
}

export default function DocsStatus({ thread }: Props) {
  if (!thread.google_doc_url) return null

  const synced = thread.last_synced_position >= thread.exchange_count

  return (
    <a
      href={thread.google_doc_url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-1.5 text-xs text-text-secondary hover:text-accent transition-colors"
      title={synced ? 'Google Doc synced' : 'Google Doc syncing...'}
    >
      {/* Google Docs icon */}
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zm-1 2l5 5h-5V4zM7 17v-2h10v2H7zm10-4H7v-2h10v2z"/>
      </svg>
      {synced ? (
        <span className="w-1.5 h-1.5 rounded-full bg-success" />
      ) : (
        <span className="w-3 h-3 border border-accent border-t-transparent rounded-full animate-spin" />
      )}
    </a>
  )
}
